import React, { Component } from 'react';
import { MdClear } from 'react-icons/md';
import { debounce } from 'lodash';
import { makeObservable } from 'mobx';
import { observer } from 'mobx-react';
import dayjs from 'dayjs';

import { Chat, TICKET_CLOSE_STATUS } from '@qbot-chat/qbot-uikit';

import { openCloseConfirm } from '../../../../helper/consultActions';
import { COMMAND_EVENT_TYPE, CONTENT_TYPE } from '@qbot-chat/qbot-uikit/chat';

import { chatStore } from '../../../../store/FrontChatStore';
import { navigateReplace } from '../../../../helper/HistoryHelper';

import { COMPANY } from '../../../../const/company';
import Favicon from '../../../../assets/company/qv-favicon.svg';
import Logo from '../../../../assets/company/qv-loading.png';
import Styles from './QvChatView.module.scss';

@observer
class QvChatView extends Component {
  constructor(props) {
    super(props);
    makeObservable(this);
  }

  debounceRequest = debounce((store) => this.request(store), 200, {
    leading: true,
  });

  request = async (store) => {
    let contentType = CONTENT_TYPE.TEXT;
    let message = {
      content: {
        type: contentType,
        value: COMMAND_EVENT_TYPE.AGENT_CONNECT,
      },
      contentType,
      createdAt: dayjs(),
    };
    store.onSendMessage(message);
  };

  render() {
    return (
      <div className={Styles.Container}>
        <Chat
          store={chatStore}
          isUser
          ref={chatStore.chatRef}
          renderCustomHeader={(store) => {
            return (
              <div className={Styles.HeaderContainer}>
                <div className={Styles.HeaderGradientBar} />
                <div className={Styles.Header}>
                  <div className={Styles.HeaderLeft}>
                    {!store.isRespond && (
                      <div
                        className={Styles.CloseButton}
                        onClick={() => {
                          openCloseConfirm(store);
                        }}
                      >
                        <MdClear size={20} />
                      </div>
                    )}
                    <img
                      src={Favicon}
                      alt={COMPANY.QV.name}
                      className={Styles.LogoMini}
                    />
                    <span className={Styles.BrandName}>
                      {COMPANY.QV.name}
                    </span>
                  </div>
                  <div className={Styles.HeaderRight}>
                    {!store.isRespond ? (
                      <>
                        {!TICKET_CLOSE_STATUS.includes(
                          store.channel?.status,
                        ) && (
                          <button
                            className={Styles.ConnectButton}
                            onClick={() => {
                              this.debounceRequest(store);
                            }}
                          >
                            상담사 연결
                          </button>
                        )}
                      </>
                    ) : (
                      <button
                        className={Styles.EndButton}
                        onClick={() => {
                          openCloseConfirm(store);
                        }}
                      >
                        상담 종료
                      </button>
                    )}
                  </div>
                </div>
              </div>
            );
          }}
          onCloseCallback={() => {
            navigateReplace(`/rating/${chatStore.channelId}`);
          }}
        />
      </div>
    );
  }
}

export default QvChatView;
